import React from 'react';
import PropTypes from 'prop-types';
import useSimpleHousehold from 'Hooks/useSimpleHousehold';
import { householdSecureFilesPreviewUri } from 'Consts/sharedUris';
import { decodeQuery, currentSearch } from 'Helpers/Query';
import { makeStyles } from '@material-ui/core';
import history from 'State/history';
import Chip from '@material-ui/core/Chip';
import { displayErrorMessage } from 'Helpers/FacetNotificationManager';

const useStyles = makeStyles(theme => ({
  fileChip: {
    margin: theme.spacing(0.5),
  },
}));

export default function FileChips({ fileCollection, onDelete, allowDelete }) {
  const classes = useStyles();
  const { householdResource } = useSimpleHousehold();

  function handleFileClick(file) {
    const currentQueries = decodeQuery(currentSearch());
    history.push(
      householdSecureFilesPreviewUri(
        householdResource.id(),
        [file.id()],
        currentQueries,
      ),
    );
  }

  function handleDelete(file) {
    file
      .link('self')
      .Delete()
      .then(onDelete)
      .catch(err => displayErrorMessage(err, 'Could not delete file'));
  }

  return fileCollection
    .resources()
    .list()
    .map((r) => {
      if (allowDelete) {
        return (
          <Chip
            className={classes.fileChip}
            key={`file.${r.id()}`}
            label={r.attr('name')}
            color="primary"
            onClick={() => handleFileClick(r)}
            onDelete={() => handleDelete(r)}
          />
        );
      }
      return (
        <Chip
          className={classes.fileChip}
          key={`file.${r.id()}`}
          label={r.attr('name')}
          color="primary"
          onClick={() => handleFileClick(r)}
        />
      );
    });
}

FileChips.propTypes = {
  fileCollection: PropTypes.object.isRequired,
  onDelete: PropTypes.func,
  allowDelete: PropTypes.bool,
};

FileChips.defaultProps = {
  onDelete: () => {},
  allowDelete: true,
};
